import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';

import ParameterDropdownComponent from './Component';

class ParameterDropdownContainer extends React.Component {
  get options () {
    return map(this.props.parameters, parameter => ({
      value: parameter.name, label: parameter.name, text: parameter.name
    }));
  }

  render () {
    const { parameters, ...props } = this.props // eslint-disable-line

    return <ParameterDropdownComponent options={this.options} {...props} />;
  }
}

ParameterDropdownContainer.propTypes = {
  parameters: PropTypes.object.isRequired
};

export default ParameterDropdownContainer;
